import { render, staticRenderFns } from "./EnviarDocumento.vue?vue&type=template&id=6b5b039e&"
import script from "./EnviarDocumento.vue?vue&type=script&lang=js&"
export * from "./EnviarDocumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports